import { createStore } from "vuex";
import axios from "axios";
import createPersistedState from "vuex-plugin-persistedstate";

export default createStore({
  state: {
    products: null,
    cart: [],
  },
  getters: {},
  mutations: {
    setProducts(state, product) {
      state.products = product;
    },
    setCart(state, product) {
      let filtered = state.products.find((item) => item?.id == product);

      // if (filtered.id == product) {
        
      // } else {
        state.cart.push(filtered);  
      // }
      
    },
    setCartDel(state, id) {
      let idx = state.cart.findIndex(item => item.id == id)
      state.cart.splice(idx, 1)
    },
  },
  actions: {
    async getProducts({ commit }) {
      try {
        let productList = await axios.get(
          "https://dummyjson.com/products?&limit=20"
        );
        let products = productList?.data?.products;
        commit("setProducts", products);
      } catch (error) {
        console.error(error);
      }
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});
